{
  "tabs": {
    "chat": "Discussion",
    "reminders": "Rappels",
    "calendar": "Calendrier",
    "settings": "Paramètres"
  },
  "common": {
    "cancel": "Annuler",
    "save": "Enregistrer",
    "confirm": "Confirmer",
    "delete": "Supprimer",
    "back": "Retour",
    "close": "Fermer",
    "edit": "Modifier",
    "search": "Rechercher",
    "all": "Tous",
    "loading": "Chargement...",
    "error": "Une erreur est survenue",
    "notFound": "Introuvable",
    "tryAgain": "Veuillez réessayer",
    "retry": "Réessayer",
    "undo": "Annuler",
    "pullToRefresh": "Tirez pour actualiser",
    "justNow": "à l'instant"
  },
  "auth": {
    "welcome": "Bienvenue sur FishMemory",
    "tagline": "Votre assistant de rappels WhatsApp, maintenant dans votre poche.",
    "subtitle": "Votre assistant de rappels WhatsApp, maintenant dans votre poche.",
    "phoneLabel": "Votre numéro WhatsApp",
    "phoneHint": "Nous enverrons un code de vérification via WhatsApp",
    "invalidPhone": "Veuillez entrer un numéro valide",
    "continue": "Continuer",
    "enterPhone": "Entrez votre numéro WhatsApp",
    "phonePlaceholder": "Numéro de téléphone",
    "sendCode": "Envoyer le code",
    "verifyTitle": "Vérifiez votre numéro",
    "otpSentTo": "Un code à 6 chiffres a été envoyé à {{phone}} via WhatsApp",
    "enterFullCode": "Veuillez entrer les 6 chiffres",
    "invalidOtp": "Code invalide. Réessayez.",
    "otpFailed": "Échec de l'envoi du code. Réessayez.",
    "otpResent": "Code renvoyé",
    "resendIn": "Renvoyer dans {{seconds}}s",
    "resendCode": "Renvoyer le code",
    "enterOtp": "Entrez le code reçu sur WhatsApp",
    "verify": "Vérifier",
    "resend": "Renvoyer le code",
    "wrongNumber": "Mauvais numéro ?",
    "backToPhone": "Retour au numéro",
    "editPhone": "Modifier le numéro",
    "error": "Erreur",
    "setupTitle": "Terminons la configuration",
    "setupSubtitle": "Vous pourrez modifier cela plus tard dans les paramètres",
    "namePlaceholder": "Votre nom",
    "letsGo": "Terminer",
    "skipForNow": "Ignorer pour le moment"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Tapez un message...",
    "inputPlaceholder": "Tapez un message...",
    "typing": "FishMemory écrit...",
    "online": "En ligne",
    "connecting": "Connexion...",
    "reconnecting": "Reconnexion...",
    "offline": "Hors ligne",
    "empty": "Commencer une conversation",
    "emptyHint": "Créez un rappel, consultez votre agenda ou demandez de l'aide.",
    "emptyAction": "Envoyer un rappel d'exemple",
    "actions": "Actions de la discussion",
    "keep": "Conserver les messages",
    "clearTitle": "Effacer la discussion",
    "clearConfirm": "Supprimer tous les messages de cet appareil ? Cette action est irréversible.",
    "clear": "Effacer la discussion",
    "optionSelected": "Sélectionné : {{label}}",
    "sendingSelection": "Envoi...",
    "connectionLost": "Reconnexion en cours..."
  },
  "reminders": {
    "title": "Mes rappels",
    "active": "Actifs",
    "today": "Aujourd'hui",
    "thisWeek": "Cette semaine",
    "history": "Historique",
    "items": "éléments",
    "emptyTitle": "Aucun rappel",
    "emptySubtitle": "Créez-en un depuis la discussion et il apparaîtra ici.",
    "emptyAction": "Ouvrir la discussion",
    "filterActive": "Actifs",
    "filterToday": "Aujourd'hui",
    "filterWeek": "Cette semaine",
    "filterHistory": "Historique",
    "emptyState": "Aucun rappel. Commencez à discuter !",
    "swipeDone": "Fait",
    "swipeSnooze": "Reporter",
    "swipeDelete": "Supprimer",
    "search": "Rechercher un rappel...",
    "upcoming": "À venir",
    "completed": "Terminés",
    "overdue": "En retard",
    "tomorrow": "Demain",
    "synced": "Synchronisé {{value}}",
    "swipeHint": "Balayez un rappel pour plus d'actions",
    "showAllCount": "Afficher les {{count}}",
    "showFewer": "Afficher moins",
    "noResults": "Aucun rappel ne correspond à votre recherche",
    "noResultsHint": "Essayez un autre mot-clé ou effacez la recherche",
    "deleteAllFailed": "Échec de la suppression de tous les rappels"
  },
  "calendar": {
    "title": "Calendrier",
    "today": "Aujourd'hui",
    "tomorrow": "Demain",
    "completed": "terminé",
    "noEvents": "Rien de prévu",
    "noEventsSubtitle": "Choisissez une date pour voir les rappels et événements.",
    "googleEvent": "Google Agenda",
    "legendActive": "Actif",
    "legendRecurring": "Récurrent",
    "legendDone": "Terminé",
    "legendGoogle": "Google",
    "previousMonth": "Mois précédent",
    "nextMonth": "Mois suivant",
    "previousYear": "Année précédente",
    "nextYear": "Année suivante",
    "goToToday": "Aller à aujourd'hui",
    "all": "Tous",
    "active": "Actif",
    "done": "Terminé",
    "paused": "En pause"
  },
  "settings": {
    "title": "Paramètres",
    "profile": "Profil",
    "name": "Nom affiché",
    "enterName": "Entrez votre nom",
    "language": "Langue",
    "uiLanguage": "Langue de l'application",
    "uiLanguageHelp": "Change l'interface, les libellés du calendrier et la direction d'affichage sur cet appareil uniquement.",
    "serverLanguage": "Langue du chat",
    "serverLanguageHelp": "Change la langue utilisée par le serveur pour les réponses et les rappels de votre compte.",
    "timezone": "Fuseau horaire",
    "currentTimezone": "Fuseau horaire actuel",
    "timezoneHelp": "Les heures des rappels sont affichées avec ce fuseau horaire.",
    "timezonePlaceholder": "Europe/Paris",
    "timezoneSave": "Enregistrer le fuseau horaire",
    "timezoneSaved": "Fuseau horaire mis à jour",
    "detect": "Détecter",
    "detectFailed": "Impossible de détecter le fuseau horaire",
    "autoDetect": "Détection auto via GPS",
    "notifications": "Notifications",
    "notificationsHelp": "Les relances contrôlent les alertes répétées après l'envoi d'un rappel. Les autorisations de notifications de l'appareil restent gérées dans les réglages du téléphone.",
    "pushEnabled": "Notifications push",
    "autoDoneOnFire": "Marquer comme terminé automatiquement",
    "autoDoneOnFireDesc": "Désactivé, les rappels restent actifs jusqu'à confirmation manuelle.",
    "googleCalendar": "Google Agenda",
    "google": "Google Agenda",
    "googleConnected": "Connecté",
    "googleDisconnected": "Non connecté",
    "googleConnectedHelp": "Les nouveaux rappels peuvent être synchronisés automatiquement.",
    "googleDisconnectedHelp": "Connectez Google Agenda pour aligner rappels et événements.",
    "googleConnectFailed": "Échec de la connexion à Google Agenda",
    "connected": "Connecté",
    "disconnected": "Non connecté",
    "connect": "Connecter",
    "disconnect": "Déconnecter",
    "autoSync": "Synchroniser automatiquement les nouveaux rappels",
    "autosync": "Synchronisation auto",
    "subscription": "Abonnement",
    "trialUsed": "Essai : {{used}}/{{total}} utilisés",
    "trialStatus": "Essai disponible",
    "activeStatus": "Abonnement actif",
    "expiredStatus": "Abonnement expiré",
    "unsubscribedStatus": "Aucun abonnement",
    "about": "À propos",
    "version": "Version",
    "logout": "Déconnexion",
    "logoutTitle": "Déconnexion",
    "logoutConfirm": "Êtes-vous sûr de vouloir vous déconnecter ?",
    "noName": "Aucun nom",
    "serverConnection": "Connexion serveur",
    "serverUrl": "URL du serveur",
    "serverEdit": "Modifier",
    "saveReconnect": "Enregistrer et reconnecter",
    "resetDefault": "Réinitialiser",
    "invalidServerUrlTitle": "URL serveur invalide",
    "invalidServerUrlMessage": "Entrez une URL http ou https valide, par exemple https://example.com",
    "uiLanguageChangeFailed": "Échec du changement de langue de l'application. Réessayez.",
    "serverLanguageChangeFailed": "Échec du changement de langue du chat. Réessayez.",
    "timezoneChangeFailed": "Échec du changement de fuseau horaire. Réessayez.",
    "autoSyncChangeFailed": "Échec de la mise à jour de la synchronisation auto. Réessayez.",
    "nameChangeFailed": "Échec de la mise à jour du nom. Réessayez.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Détails du rappel",
    "editTime": "Modifier l'heure",
    "rename": "Renommer",
    "snooze": "Reporter",
    "snooze15": "Reporter de 15 minutes",
    "pause": "Mettre en pause",
    "pauseReminder": "Mettre le rappel en pause",
    "resume": "Reprendre",
    "resumeReminder": "Reprendre le rappel",
    "skip": "Passer le suivant",
    "skipOccurrence": "Passer cette occurrence",
    "syncGoogle": "Synchroniser avec Google",
    "delete": "Supprimer",
    "deleteTitle": "Supprimer le rappel",
    "deleteConfirm": "Ce rappel sera supprimé définitivement.",
    "deleteRecurringTitle": "Supprimer le rappel récurrent",
    "deleteRecurringMessage": "Voulez-vous passer cette occurrence ou supprimer toute la série ?",
    "deleteThisOccurrence": "Passer cette occurrence",
    "deleteEntireSeries": "Supprimer toute la série",
    "done": "Terminé",
    "markDone": "Marquer comme terminé",
    "undo": "Réactiver",
    "undoPrompt": "Besoin de le rendre actif à nouveau ? Réactivez-le maintenant.",
    "recurring": "Récurrent",
    "nextRun": "Prochaine occurrence",
    "oneTime": "Unique",
    "pending": "En attente",
    "sent": "Envoyé",
    "paused": "En pause",
    "active": "Actif",
    "snoozed": "Reporté",
    "localTime": "Affiché selon l'heure locale de l'appareil",
    "recurrence": "Récurrence",
    "created": "Créé",
    "tags": "Étiquettes",
    "fireCount": "Nombre d'envois",
    "actions": "Actions",
    "none": "Aucun",
    "snoozeFailed": "Échec du report du rappel",
    "pauseFailed": "Échec de la mise en pause du rappel",
    "resumeFailed": "Échec de la reprise du rappel",
    "skipFailed": "Échec du saut du rappel",
    "doneFailed": "Échec du marquage comme terminé",
    "undoFailed": "Échec de la réactivation du statut du rappel",
    "deleteFailed": "Échec de la suppression du rappel",
    "rescheduleTitle": "Replanifier ?",
    "rescheduleMsg": "Ce rappel est en retard. Voulez-vous le replanifier ?",
    "reschedule15": "Dans 15 minutes",
    "reschedule60": "Dans 1 heure",
    "keepOverdue": "Garder tel quel"
  }
}
